export default __webpack_public_path__ + "static/media/LoginSVG.11923ad4.svg";